import React from 'react';
import Table from '../../components/Table';
import { usePurchases } from 'hooks/usePurchases';

function Purchases() {
  const {
    purchases,
    openProgress,
    columns,
    columnsForExport,
    exportData,
  } = usePurchases();

  return (
    <Table
      title="Compras"
      route="/purchases/"
      routeAdd="/type-purchase/"
      routeClick="/purchase/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={purchases}
      exportData={exportData}
      dataLoaded={openProgress}
    />
  );
}

export default Purchases;
